
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

interface StoreData {
  id: string | number
  storeName: string
  companyName: string
  storeHeadPortrait?: string
}

@Component({
  name: 'DisbindConfirm'
})
export default class DisbindConfirm extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean
  @Prop({ type: Object, required: true }) storeData!: StoreData

  visible = false

  @Watch('value', { immediate: true })
  onValueChange(val: boolean) {
    this.visible = val
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.$emit('input', val)
  }

  // 取消
  onCancel() {
    this.visible = false
    this.$emit('cancel')
  }

  // 确认
  onConfirm() {
    this.visible = false
    this.$emit('confirm', this.storeData)
  }
}
